export const HIDE_ALL_PANELS = 'HIDE_ALL_PANELS'
export const HIDE_PANEL = 'HIDE_PANEL'
export const SHOW_PANEL = 'SHOW_PANEL'
export const UPDATE_INDIVIDUAL = 'UPDATE_INDIVIDUAL'
